// extracted by mini-css-extract-plugin
export default {"layout":"b8f954914a e8c0e13363 f920495457","h_slide":"_7aa7cc7ebe","category":"_1e04ac8504 _3036eff6c6 _09845498e7"};